"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfResponseModel = instanceOfResponseModel;
exports.ResponseModelFromJSON = ResponseModelFromJSON;
exports.ResponseModelFromJSONTyped = ResponseModelFromJSONTyped;
exports.ResponseModelToJSON = ResponseModelToJSON;
exports.ResponseModelToJSONTyped = ResponseModelToJSONTyped;
/**
 * Check if a given object implements the ResponseModel interface.
 */
function instanceOfResponseModel(value) {
    return true;
}
function ResponseModelFromJSON(json) {
    return ResponseModelFromJSONTyped(json, false);
}
function ResponseModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : json['data'],
    };
}
function ResponseModelToJSON(json) {
    return ResponseModelToJSONTyped(json, false);
}
function ResponseModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'success': value['success'],
        'message': value['message'],
        'data': value['data'],
    };
}
